import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { TextField } from '@michelin/acid-components'

const styles = theme => ({
	textField: {
		marginLeft: 0,
		marginRight: 0,
	},
})

class MaterialInputable extends React.Component {
	constructor(props) {
		super(props)

		this.state = {}
	}

	render() {
		const { value, autoUpdate, errorMessage, classes, ...otherProps } = this.props

		if (autoUpdate) {
			otherProps.value = value
		} else {
			otherProps.defaultValue = value
		}

		return(
			<TextField
				{...otherProps}
				helperText={errorMessage}
			/>
		)
	}
}

MaterialInputable.propTypes = {
	classes: PropTypes.object,
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	placeholder: PropTypes.string,
	error: PropTypes.bool,
	errorMessage: PropTypes.string,
	autoFocus: PropTypes.bool,
	autoUpdate: PropTypes.bool,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	multiline: PropTypes.bool,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	onKeyPress: PropTypes.func, 
	InputProps: PropTypes.object,
	InputLabelProps: PropTypes.object
}

MaterialInputable.defaultProps = {
	value: '',
	label: '',
	placeholder: '',
	errorMessage: '',
	autoFocus: false,
	autoUpdate: false,
	disabled: false,
	required: false,
	multiline: false,
	error: false,
}

export default withStyles(styles)(MaterialInputable)


// WEBPACK FOOTER //
// ./src/components/MaterialInputable.js